import { isLocal } from './isLocal';

// Get Institution name from URL
const getInstitutionNameForSentry = () => {
  if (isLocal) {
    return;
  }
  const host = window.location.hostname;
  const re = /([.])(?:(?=(\\?))\2.)*?\1/;
  // eslint-disable-next-line consistent-return
  return host.match(re)[0].replace(/\./g, '');
};

export default getInstitutionNameForSentry;
